module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"widgets.newMessageCount.widget":[{"value":"newMessageCountService","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101002},"path":"@root","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/messageCountService.js
// module id = 696
// module chunks = 4